import PropTypes from 'prop-types';
import React from 'react';
import LibAccordion from 'react-bootstrap/Accordion';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import styled from 'styled-components';

import { theme } from '_constants/theme';
import { hexToRGBA } from '_helpers/theme';

const StyledContainer = styled.div`
  padding: ${theme.spaces.regular}px;
  margin-bottom: ${theme.spaces.smallX}px;
  border-radius: 8px;
  background: ${hexToRGBA(theme.colors.indigo.primary, 0.08)};
`;

const StyledHeader = styled.div`
  display: flex;
  cursor: pointer;
`;

const StyledIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-left: ${theme.spaces.regular}px;
`;

const StyledTitle = styled.div`
  flex-grow: 1;
`;

const StyledBody = styled.div`
  margin-top: ${theme.spaces.regular}px;
  padding-top: ${theme.spaces.regular}px;
  border-top: 1px solid ${hexToRGBA(theme.colors.gray.primary, 0.08)};
`;

const AccordionItem = ({ eventKey, title, children, open, openIcon, closeIcon, onToggle }) => {
  const handleToggle = useAccordionButton(eventKey, () => onToggle && onToggle(eventKey));

  return (
    <StyledContainer>
      <StyledHeader onClick={handleToggle}>
        <StyledTitle>{title}</StyledTitle>
        <StyledIconContainer>{open ? openIcon : closeIcon}</StyledIconContainer>
      </StyledHeader>
      <LibAccordion.Collapse eventKey={eventKey}>
        <StyledBody>{children}</StyledBody>
      </LibAccordion.Collapse>
    </StyledContainer>
  );
};

AccordionItem.propTypes = {
  eventKey: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  open: PropTypes.bool,
  openIcon: PropTypes.node,
  closeIcon: PropTypes.node,
  onToggle: PropTypes.func,
};

export default AccordionItem;
